import { useMemo } from 'react'
import { processData, processHeaderData } from 'mappers/mtcOutputMappers'
import { useDataContext } from 'context/DataContext'
import { useDataDomain } from 'utils/hooks'
import {
    ReportDataById,
    DisplayableDomainItem,
    HeaderDataById,
    HeaderDataEntry
} from 'reportViewer'

export const useEvidenceData = (
    domainItemId?: string
): {
    currentDomainItem: DisplayableDomainItem | null
    currentHeaderItem: HeaderDataEntry | null
    loading: boolean
} => {
    const domain = useDataDomain()
    const { [domain]: domainItems } = useDataContext()

    const displayableDomainItems: ReportDataById | null = useMemo(() => {
        if (domainItems && domain && domainItemId) {
            return processData(domainItems)
        }
        return null
    }, [domain, domainItems, domainItemId])

    const evidenceHeaderItems: HeaderDataById | null = useMemo(() => {
        if (domainItems && domain && domainItemId) {
            return processHeaderData(domainItems)
        }
        return null
    }, [domain, domainItems, domainItemId])

    const loading =
        !displayableDomainItems || !evidenceHeaderItems || !domainItemId
    const currentDomainItem = !loading
        ? displayableDomainItems[Number(domainItemId)]
        : null

    const currentHeaderItem = !loading
        ? evidenceHeaderItems[Number(domainItemId)]
        : null

    return { currentDomainItem, currentHeaderItem, loading }
}
